'use client';
import { JumboCard, JumboScrollbar } from 'themes/jumbo/@jumbo/components';
import {
  Chip,
  Typography,
  Button,
  Tooltip
} from '@mui/material';
import { PendingList } from './components';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FoldersActions } from "actions";
import { useHistory } from 'react-router-dom';
import { getFileIcon } from "actions/GlobalActions";
import { trackEvent } from "components/Tracking";
import { useState, useEffect } from "react";
import _ from 'utils/@lodash';

const define_status = (str: string) => {
  return typeof str === "string" && str.length > 0 ? str : "Pending processing...";
};

const PendingCard = ({title, filter}:{title:React.ReactNode, filter:string}) => {
	const data = useSelector((state: any) => state.cache.data);
  const entities = data.entities;
  const projects = data.projects;
  const pendingData: any[] = [];
  const _list = [...Object.entries(entities)]
  const history = useHistory();
  const handleClick = (e: any) => {
    trackEvent("Dashboard", "Pendings", "Btn_All");
    history.push(`/pending`);
  };

  const storeAuthData = useSelector((state: any) => state.auth);
  const { defaultProjects } = storeAuthData;
  //const demoProjectsHidden = Number(localStorage.getItem('hideDemoProjects') || 0) > 0;

  const [list, setList] = useState<any[]>(_list);

  useEffect(() => {
    const data = _list
                    .filter((item: any) => !defaultProjects.includes(item[0]))
                    .filter((item: any) => filter !== 'all' ? item[0] === filter : item[0] !== null);
    !_.isEqual(data, list) && setList(data);
  }, [_list, list, defaultProjects, filter])

  list.map((entry: any, index: number) => {
    const id = entry[0];
    const pending: any = Object.values(entry[1]).filter((p: any) => {
      return p.state === "PARTIAL" && p.type === "FILE" && p.name;
    });
    if (!projects[id] || pending.length < 1) return;
    pending.map((p: any, index: number) => {
      if(!p) return;
      const workflow = FoldersActions.getWorkflowFromEntity(p);
      const status = typeof p["partial_status"] === "string" && p["partial_status"].length > 0
        ? define_status(p["partial_status"])
        : "Waiting in queue...";

      const isProgress = typeof p["partial_status"] === "string" && p["partial_status"].length > 0;
      pendingData.push({
        projectID: id,
        projectName: projects[id].name,
        path: FoldersActions.getPathFromEntity(p),
        workflow,
        products: (workflow?.products || []).join(" - "),
        date: p.file_date,
        fileName: getFileIcon(p),
        name: p.name,
        status,
        isProgress,
        progress: parseInt(p["partial_progress"]) || 0,
      })
    })

  });

  const CardTitle = () => (
    <div style={{display: "flex", justifyContent: 'space-between'}}>
      <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
        <Typography color={'text.primary'} variant={'h6'} mb={0}>
          {title}
        </Typography>
        <Chip
          size={'small'}
          label={pendingData.length}
          color='success'
          sx={{
            textAlign: 'center',
            backgroundColor: '#868484ff',
            transform: 'scale(.8)'
          }}
        />
      </div>
      {pendingData.length > 0 && (
        <div style={{display: "flex", gap: '10px', alignItems: 'center'}}>
          <Tooltip title="All pendings" placement="top" arrow>
            <Button
              size={'small'}
              variant={'outlined'}
              onClick={handleClick} 
              style={{height: '25px', minWidth: 'auto'}}
            >
              All
            </Button>
          </Tooltip>
        </div>
      )}
    </div>
  )

  return (
    <JumboCard
      title={<CardTitle />}
      contentWrapper
      contentSx={{ p: 0, minHeight: '150px' }}
    >
      <JumboScrollbar autoHeight autoHeightMin={100}>
        <PendingList pendingList={pendingData} />
      </JumboScrollbar>
    </JumboCard>
  );
};

export { PendingCard };
